import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';

export interface ImageText {
  productName: string;
  shortText: string;
}
interface Props {
  image: ImageProps;
  text?: ImageText;
}

const ImageAndText = ({ image, text }: Props) => {
  return (
    <div key={image?.image?.id} className="tw-flex tw-align-center tw-flex-col tw-text-center">
      <LazyLoadImage
        imgComponent={
          /* eslint-disable-next-line @next/next/no-img-element */
          <img src={buildImageSrc(image, 1, 1, 1)} alt={image.altTag} height="100%" width="auto" />
        }
      />
      {text && (
        <div className="tw-pt-5">
          {text?.productName && (
            <h5 className="tw-text-warm-400 tw-mb-0 tra-text-heading-h5">{text.productName}</h5>
          )}
          {text?.shortText && (
            <p className="tw-text-neutral-100 tw-mb-0 tra-text-web-body-xl">{text.shortText}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageAndText;
